import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const FETCH_HOME_WIDGET_LIST_API_ID = 'DASHBOARD/FETCH_HOME_WIDGET_LIST_API_ID';

const apiCall = createApiCall(FETCH_HOME_WIDGET_LIST_API_ID, params => ({
  endpoint: generateEndpoint({
    host: `/api/admin/home-widgets`,
    params,
  }),
  method: 'GET',
}));

export default apiCall;
